import {Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {Router} from "@angular/router";

import {ExampleSJ, Word} from "../../models/word.model";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {OptionService} from "../../services/option/option.service";
import {VoiceService} from "../../services/voice/voice.service";
import {TfSpiceService} from "../../services/tf-service/tf-spice.service";
import {PitchService} from "../../services/pitch/pitch.service";
import {RecorderService} from "../../services/recorder/recorder.service";
import {PitchPopupComponent} from "../pitch-popup/pitch-popup.component";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";


@Component({
  selector: 'app-example-popup',
  templateUrl: './example-popup.component.html',
  styleUrls: ['./example-popup.component.scss']
})
export class ExamplePopupComponent extends PitchPopupComponent implements OnInit {
  @Input() override word: Word | null = null;
  @Input() public exampleSJ: ExampleSJ | null = null;

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    protected override router: Router,
    protected override optionSvc: OptionService,
    protected override voiceSvc: VoiceService,
    protected override spiceSvc: TfSpiceService,
    protected override pitchSvc: PitchService,
    protected override recorderSvc: RecorderService,
    protected override lm: LayoutMgrService,
  ) {
    super(elementRef, renderer, globalEventSvc, router, optionSvc, voiceSvc, spiceSvc, pitchSvc, recorderSvc, lm);
  }

  override async ngOnInit(): Promise<void> {
    if (this.word && 'exampleVoice' in this.word && this.exampleSJ?.voiceExIdx !== null) {
      const exVoiceIdx = this.exampleSJ!.voiceExIdx;
      const urlVoice = this.word?.exampleVoice[exVoiceIdx];

      this.init(urlVoice, exVoiceIdx);
    }
  }

  // override ngOnDestroy(): void {
  //   this.coDestroy();
  //
  //   // 프로그래스바 종료
  //   this.pbExit();
  // }

  // onClose($event: MouseEvent) {
  //   $event.preventDefault();
  //   $event.stopPropagation();
  //   this.globalEventSvc.Click($event);
  //
  //   this.close.emit(this.exampleSJ);
  // }


  /**
   * 녹음 버튼 클릭 처리 함수
   * 녹음을 시작하거나 녹음을 중단함.
   * @param event
   */
  override onClickRecord($event: MouseEvent) {

  }

  /**
   * 녹음 중지 처리 함수
   */
  protected override onStopRecord(): void {

  }
}
